import { FormattedMessage } from 'react-intl';
import { PaloConfirmationDialog } from '@synergy/components-palo';
import { PoolFormattedMessage } from '@synergy/components';
import { useEffect } from 'react';

import * as HeaderBannerDetailActions from '../header-banner-detail/store/header-banner-detail-actions';
import { headerBannerDetailSelector } from '../header-banner-detail/store/header-banner-detail-selectors';
import { useAppSelector } from '../../../../store/use-appstate-selector';
import { useThunkDispatch } from '../../../../store/use-thunk-dispatch';

interface HeaderBannerDeleteModalProps {
    onDelete: () => void;
    isVisible: boolean;
    handleClose: () => void;
    id?: number | null;
}

export const HeaderBannerDeleteModal = (props: HeaderBannerDeleteModalProps) => {
    const { isVisible, id, handleClose, onDelete } = props;
    const headerBanner = useAppSelector(headerBannerDetailSelector);
    const currentLocale = useAppSelector(state => state.currentLocale);
    const dispatch = useThunkDispatch();

    useEffect(() => {
        if (id) {
            dispatch(HeaderBannerDetailActions.fetchHeaderBannerDetail(id));
        }

        return () => {
            dispatch(HeaderBannerDetailActions.resetHeaderBannerDetail());
        };
    }, [dispatch, id]);

    return (
        <PaloConfirmationDialog
            isVisible={isVisible}
            title={<FormattedMessage id="app.contentManagement.headerBanner.delete" />}
            action={<FormattedMessage id="app.common.delete" />}
            onConfirm={onDelete}
            onCancel={handleClose}
        >
            <PoolFormattedMessage
                id="app.contentManagement.headerBanner.deleteWarning"
                values={{ name: headerBanner?.headline && headerBanner?.headline[currentLocale] }}
            />
        </PaloConfirmationDialog>
    );
};
